module.exports = __webpack_public_path__ + "static/img/9.68284c66.png";